import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Overview from "./AMRDashboard/Overview";
import CategoryPage from "./AMRDashboard/CategoryPage";
import PrivateComponent from "./AMRDashboard/Login/PrivateComponent";
import Login from "./AMRDashboard/Login/Login";
import PublicRoute from "./AMRDashboard/Login/PublicRoute";
import UserInfoPage from "./AMRDashboard/UserInfoPage";

function App() {
  return (
    <div className="App">
      <Router basename="/">
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route element={<PrivateComponent />}>
            <Route path="/" element={<Overview />} />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/userinfo" element={<UserInfoPage />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
